import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'microsoft-onedrive',
  name: 'Microsoft OneDrive',
  category: 'integrations',
  description: 'Interact with Microsoft OneDrive via Microsoft Graph API. Manage files and folders in user\'s personal or business OneDrive.',
  icon: 'microsoft-onedrive',
  iconType: 'microsoft-icon',
  color: 'blue',
  version: '1.0.0',
  group: ['transform'],
  defaults: {
    name: 'Microsoft OneDrive',
    color: '#0078d4',
  },
  credentials: [
    {
      name: 'microsoft_onedrive_oauth',
      required: true,
      displayName: 'Microsoft OneDrive OAuth2',
      displayOptions: {
        show: {
          useCredential: [true],
        },
      },
    },
  ],
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  tags: ['microsoft', 'onedrive', 'cloud', 'storage', 'files', 'folders', 'microsoft-graph', 'drive', 'share'],
  comingSoon: false,
};

export default definition;
